import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventosService } from 'src/app/services/eventos.service';
import { OrdersEventService } from 'src/app/services/orders-event.service';
import { ReportsService } from 'src/app/services/reports.service';
import { OrdersBillingComponent } from '../orders-billing/orders-billing.component';
import { ApiSalesService } from 'src/app/services/api-sales.service';

@Component({
  selector: 'app-orders-table',
  templateUrl: './orders-table.component.html',
  styleUrls: ['./orders-table.component.scss'],
})
export class OrdersTableComponent implements OnInit, OnChanges {
  @Input() idEvent!: any;
  orders!: any[];
  searchText!: string;
  filterOrders!: any;

  displayedColumns: string[] = [
    'options',
    'id',
    'id_invoicing',
    'name',
    'email',
    'channel',
    'created_at',
    'total',
    'status',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort = new MatSort();

  page = 1;
  totalPages = 1;

  sorted!: any;
  loaded: boolean = false;
  @Input() loadingPage: boolean = true;
  finishScroll: boolean = false;
  @ViewChild('containerScroll', { static: false }) containerScroll: ElementRef;
  private ordersRequest?: Subscription;
  private loadGeneration = 0;

  @Input() activeSelectList: boolean = false;
  allSelected: boolean = false;
  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();

  @Input() priceFilters: any = { min: null, max: null };
  @Input() business!: any;
  @Input() places: any[] = [];
  placeSelected!: any;
  allowCancel: boolean = false;

  allowCitylok: boolean = false;
  now: Date = new Date();
  channelsOptions: any[] = [];
  statusOptions: any[] = [];
  firstLoaded: boolean = true;

  // Canales permitidos para devoluciones (Totem y Online)
  // Ajustar estos IDs según los canales reales del sistema
  private readonly REFUNDABLE_CHANNELS = [1, 2]; // 1=Online, 2=Totem (ajustar según sea necesario)

  constructor(
    private dialog: MatDialog,
    private orderService: OrdersEventService,
    private eventosService: EventosService,
    private apiSalesService: ApiSalesService,
    private router: Router,
    private reportService: ReportsService,
    private apiBusiness: ApiBusinessService,
    private auth: AuthenticationService,
  ) {}

  ngOnInit(): void {
    let rolesProfile = this.auth
      .getProfile()
      ?.roles.map((role: any) => role.name);
    this.allowCancel =
      rolesProfile?.includes('superadmin') || rolesProfile?.includes('admin');
    this.allowCitylok = this.auth.isSuperAdmin();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['places'] && !changes['places'].firstChange) {
      this.orders = [];
      this.updateOders();
    }
  }

  ngAfterViewInit() {
    this.business = JSON.parse(localStorage.getItem('business') || '{}');
    this.apiSalesService.getAllMethods().subscribe({
      next: (res) => {
        this.channelsOptions = res?.data || [];
      },
    });
    this.apiSalesService.getStatusByBusiness().subscribe({
      next: (res) => {
        this.statusOptions = res?.data || [];
      },
    });

    let dataLoaded = false;

    this.orderService.filtersOrderStorage.subscribe({
      next: (res) => {
        // Solo actualizamos si realmente hay datos, si es null (por el clear) no disparamos updateOders
        if (res) {
          let place = localStorage.getItem('places');
          this.placeSelected = place;
          this.searchText = res?.searchOrder;
          this.filterOrders = res?.filterOrders;
          this.updateOders();
        } else {
          // Si llega null, nos aseguramos que lo local también esté limpio
          this.searchText = '';
          this.filterOrders = null;
        }
      },
    });
    this.apiBusiness.changed.subscribe({
      next: (value) => {
        if (value) {
          this.business = JSON.parse(
            localStorage.getItem('business') || '{}',
          );
          this.orders = [];
          dataLoaded = true;
          this.updateOders();
        }
      },
    });

    // Cargar datos iniciales si business está definido y no se cargó via observables
    setTimeout(() => {
      if (!dataLoaded && this.business?.id) {
        this.orders = [];
        this.updateOders();
      }
    }, 500);
  }

  getData() {
    const generation = this.loadGeneration;
    // Usar placeFilter del objeto de filtros si está disponible (tiene precedencia sobre el Input)
    // para evitar condiciones de carrera entre filtersOrderStorage y ngOnChanges
    const placesToSend = this.filterOrders != null
      ? (this.filterOrders.placeFilter ? [this.filterOrders.placeFilter] : [])
      : this.places;
    this.ordersRequest = this.orderService
      .getReportsByBusiness(
        this.business.id,
        this.page,
        this.searchText,
        this.filterOrders,
        this.sorted,
        this.idEvent,
        placesToSend,
      )
      .subscribe({
        next: (res) => {
          if (generation !== this.loadGeneration) return;
          if (res.data.data.length > 0) {
            this.contentTable(res.data);
            this.loadingPage = false;
            this.loaded = true;
            this.finishScroll = true;
          } else {
            this.contentTable(res.data);
            this.loadingPage = false;
            this.finishScroll = true;
            this.loaded = true;
          }
        },
      });
  }

  getChannelName(channel: any) {
    let name = '';
    if (
      Array.isArray(this.channelsOptions) &&
      this.channelsOptions.length > 0
    ) {
      let channelFind = this.channelsOptions.find(
        (value) => value.id == channel,
      );
      if (channelFind) {
        name = channelFind.name;
      }
    }
    return name;
  }

  getStatus(status_order: number) {
    if (Array.isArray(this.statusOptions) && this.statusOptions.length > 0) {
      return this.statusOptions.find((value) => value.id == status_order);
    }
    return null;
  }

  contentTable(result: any) {
    this.orders = this.orders.concat(result.data);
    if (this.orders.length <= 0 || this.orders.length < 15) {
      this.finishScroll = true;
    }
    this.dataSource = new MatTableDataSource(this.orders);
    this.totalPages = result.data.length < 15 ? this.page : this.page + 1;
    this.loaded = true;
    this.loadingPage = false;
    // Cambiar estado de loading filters
    this.orderService.setLoadingTable(false);
    if (this.allSelected) {
      this.selectAll();
    }
  }

  updateOders() {
    this.ordersRequest?.unsubscribe();
    this.loadGeneration++;
    this.page = 1;
    this.finishScroll = false;
    this.orders = [];
    this.loadingPage = true;
    this.loaded = false;
    this.firstLoaded = false;
    this.getData();
  }

  openOrder(id: number) {
    let url = '/panel-control/orders/detail/info-order';
    if (this.idEvent) {
      // Construir URL relativa en lugar de absoluta
      const params = new URLSearchParams({ search: `${id}` });
      const urlOpen = `${url}?${params.toString()}`;

      // Abrir en nueva pestaña usando el mismo origen
      const newWindow = window.open(urlOpen, '_blank');

      // Verificar si se bloqueó el popup
      if (
        !newWindow ||
        newWindow.closed ||
        typeof newWindow.closed == 'undefined'
      ) {
        // Si se bloqueó, usar router.navigate
        this.router.navigate([url], { queryParams: { search: id } });
      }
    } else {
      this.router.navigate([url], { queryParams: { search: id } });
    }
  }

  /**
   * Verifica si el pedido puede ser devuelto según el canal, rol del usuario y fecha
   * - Superadmin: puede devolver Totem y Online de cualquier fecha
   * - Admin: puede devolver Totem y Online solo del mismo día
   * - Otros canales (Efectivo, TPV): no se pueden devolver
   */
  canRefundOrder(order: any): boolean {
    if (!order) return false;

    // Obtener el nombre del canal
    const channelName = this.getChannelName(order.id_channel);

    // Verificar que NO sea Efectivo ni TPV
    if (channelName === 'Efectivo' || channelName === 'TPV') {
      return false;
    }

    // Verificar si el canal está en la lista de canales permitidos
    const isRefundableChannel = this.REFUNDABLE_CHANNELS.includes(
      order.id_channel,
    );
    if (!isRefundableChannel) return false;

    // Superadmin puede devolver cualquier día
    if (this.allowCitylok) return true;

    // Admin solo puede devolver si es del mismo día
    if (this.isAdmin()) {
      return this.isSameDay(order.created_at);
    }

    return false;
  }

  /**
   * Verifica si el usuario es admin pero NO superadmin
   */
  private isAdmin(): boolean {
    const roles =
      this.auth.getProfile()?.roles.map((role: any) => role.name) || [];
    return roles.includes('admin') && !this.auth.isSuperAdmin();
  }

  /**
   * Verifica si la fecha del pedido es del mismo día que hoy
   */
  private isSameDay(orderDate: any): boolean {
    const orderDay = new Date(orderDate).toDateString();
    const today = this.now.toDateString();
    return orderDay === today;
  }

  containsBlocked() {
    return (
      this.selectedItems.filter((item) => item.status?.name == 'pending')
        .length > 0
    );
  }

  getColorStatus(statusKey: string) {
    let color = '';
    switch (statusKey) {
      case 'pending':
        color = '#E9A41B';
        break;
      case 'processing':
        color = '#E9A41B';
        break;
      case 'paid':
        color = '#2DAE29';
        break;
      case 'completed':
        color = '#2DAE29';
        break;
      case 'refund':
        color = '#13CDE2';
        break;
      case 'partial_refund':
        color = '#13CDE2';
        break;
      default:
        color = '#ff0000';
        break;
    }
    return color;
  }

  downloadTicketOrder(idOrder: number, type: string) {
    this.reportService.getUrlsDownload(idOrder).subscribe({
      next: (url) => {
        let param = type == 'a4' ? 'ticket_a4' : 'ticket';
        let uriDownload = url.data[param];
        window.open(uriDownload, '_blank');
        this.openInfoCard(
          'Se ha descargado el ticket correctamente.',
          false,
          false,
        );
      },
      error: (err) => {
        this.openInfoCard(
          'Lo sentimos, no se han podido descargar las entradas.',
          true,
          false,
        );
      },
    });
  }

  openInfoCard(
    msg: string,
    disabledClose: boolean = false,
    icon: boolean = true,
  ) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false,
      },
    });
  }

  // Sort
  sortData(sort: Sort) {
    // Alternar manualmente entre asc y desc si la columna es la misma
    if (sort.direction) {
      if (
        this.sorted &&
        this.sorted.orderBy === sort.active &&
        this.sorted.order === 'asc' &&
        sort.direction === 'asc'
      ) {
        // Si ya estaba en ascendente y vuelve a clickear, cambiar a descendente
        this.sorted = { orderBy: sort.active, order: 'desc' };
      } else {
        this.sorted = { orderBy: sort.active, order: sort.direction };
      }
    } else {
      this.sorted = null;
    }
    this.updateOders();
  }

  //Pagination
  @HostListener('window:scroll', ['$event'])
  @HostListener('scroll', ['$event'])
  public isScrolledInfinityView(event) {
    if (
      !this.loadingPage &&
      this.containerScroll &&
      this.containerScroll.nativeElement
    ) {
      if (this.page < this.totalPages && !this.finishScroll) {
        const element =
          this.containerScroll.nativeElement.getBoundingClientRect();
        let bottomShown = element.bottom <= window.innerHeight;
        if (
          event.target.offsetHeight + event.target.scrollTop >=
          event.target.scrollHeight
        ) {
          bottomShown = true;
        }
        if (bottomShown && !this.finishScroll) {
          this.page++;
          this.loadingPage = true;
          setTimeout(() => {
            this.getData();
          }, 200);
        }
        // }
      } else {
        this.finishScroll = false;
      }
    }
  }

  selectAll() {
    this.dataSource.data.forEach((item) => (item.selected = this.allSelected));
    this.selectedItems = this.dataSource.data.filter((item) => item.selected);
    this.selectedItemsChange.emit(this.selectedItems);
  }

  changeSelectItem(item: any) {
    item.selected = !item.selected;
    this.selectedItems = this.dataSource.data.filter((item) => item.selected);
    this.allSelected =
      this.selectedItems.length === this.dataSource.data.length;
    this.selectedItemsChange.emit(this.selectedItems);
  }

  cancelPendingOrder(order: any) {
    // Pedir confirmación
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres cancelar el pedido? Esta acción no podrá deshacerse.',
        btnCancel: true,
        warning: true,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.reportService.cancelPendingOrder(order.id).subscribe({
          next: (url) => {
            this.openInfoCard(
              'Se ha cancelado el pedido correctamente.',
              false,
              false,
            );
          },
          error: (err) => {
            this.openInfoCard(
              'Lo sentimos, no se ha podido cancelar el pedido, vuelve a intentarlo más tarde.',
              true,
              false,
            );
          },
        });
      }
    });
  }

  cancelOrder(order: any) {
    // Solo superadmin puede elegir devolver gastos de gestión
    // Admin siempre devuelve sin gastos de gestión
    if (this.allowCitylok) {
      const dialogRefFees = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        disableClose: true,
        data: {
          icon: true,
          text: '¿Deseas devolver también los gastos de gestión?',
          btnCancel: true,
          warning: false,
        },
      });

      dialogRefFees.afterClosed().subscribe((refundFees) => {
        if (refundFees !== null && refundFees !== undefined) {
          this.proceedWithRefund(order, refundFees);
        }
      });
    } else {
      // Admin: proceder sin gastos de gestión
      this.proceedWithRefund(order, false);
    }
  }

  private proceedWithRefund(order: any, refundFees: boolean) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      disableClose: true,
      data: {
        icon: true,
        text: '¿Estás seguro de que quieres devolver el pedido? Esta acción no podrá deshacerse.',
        btnCancel: true,
        warning: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const payload = refundFees ? { refund_fees: true } : {};
        this.reportService
          .cancelOrder(this.allowCitylok, order.id, payload)
          .subscribe({
            next: (url) => {
              order.status = { id: 4, name: 'Devuelto', short_name: 'refund' };
              this.openInfoCard(
                'Se ha devuelto el pedido correctamente.',
                false,
                false,
              );
            },
            error: (err) => {
              this.openInfoCard(
                'Lo sentimos, no se ha podido devolver el pedido, vuelve a intentarlo más tarde.',
                true,
                false,
              );
            },
          });
      }
    });
  }

  openInfoPayment(order: any) {
    this.reportService.getInfoTransaction(order.id).subscribe({
      next: (res) => {
        this.dialog.open(OrdersBillingComponent, {
          panelClass: 'info-dialog',
          data: {
            billing: res.data,
            order: order,
            id: order.id,
            // El listado devuelve el número fiscal en invoice_number; num_ticket
            // es el nombre que usa el TPV y aquí nunca llegaba relleno, así que
            // la cabecera acababa cayendo al id interno de la web.
            num_ticket: order.invoice_number,
            user: this.auth.getProfile(),
            channel: this.getChannelName(order.id_channel),
          },
        });
      },
      error: (err) => {
        this.openInfoCard(
          'Lo sentimos, no se ha podido obtener la información del pedido, vuelve a intentarlo más tarde.',
          true,
          false,
        );
      },
    });
  }

  sendEmailConfirm(order: any) {
    this.reportService.sendEmailConfirm(order.id, {}).subscribe({
      next: (data) => {
        this.openInfoCard(
          'Las entradas se han enviado correctamente.',
          false,
          false,
        );
      },
      error: (err) => {
        this.openInfoCard(
          '¡Vaya! Algo ocurrido un error al mandar el correo, vuelve a intentarlo más tarde.',
          true,
          false,
        );
      },
    });
  }

  ngOnDestroy(): void {
    // Solo limpiar los filtros si el usuario NO está navegando al detalle de un pedido
    // (en ese caso queremos conservarlos para poder restaurarlos al volver)
    if (!this.router.url?.includes('orders/detail')) {
      this.orderService.clearAllFilters();
    }
    this.orders = [];
  }
}
